module.exports = __webpack_public_path__ + "assets/img/logo.4c28cd8d.png";